import { inject, Injectable } from '@angular/core';
import { ApiService } from '../../../../core/services/ApiService';
import { IResponse } from '../../../../core/interfaces/IResponse';
import { Observable, Subject, tap } from 'rxjs';
import { KioskStore } from '../stores/KioskStore';
import { EmployeesStore } from '../../../employees/core/stores/EmployeesStore';
import { IKioskTab } from '../interfaces/IKioskTab';
import { TerminalsStore } from '../../../terminals/core/stores/TerminalsStore';
import { IKioskProductsAndPackages } from '../interfaces/IKioskProductsAndPackages';
import { IKioskProduct } from '../interfaces/IKioskProduct';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class KioskService {

  public readonly productToAdd$ = new Subject<IKioskProduct>();

  private readonly _basePath = '/kiosk';
  private readonly _apiService = inject(ApiService);
  private readonly _employeesStore = inject(EmployeesStore);
  private readonly _kioskStore = inject(KioskStore);
  private readonly _terminalsStore = inject(TerminalsStore);

  public getMandatorKioskTabs(): Observable<IResponse<IKioskTab[]>> {
    return this._apiService.get(`${this._basePath}/tabs/${this._employeesStore.myEmployee().mandator.id}`).pipe(
      tap(res => this._kioskStore.kioskTabs.set(res.data.sortByKey('position')))
    );
  }

  public getKioskProductsAndPackages(): Observable<IResponse<IKioskProductsAndPackages>> {
    let httpParams = new HttpParams();
    const layoutTypeId = this._terminalsStore.selectedTerminal().parKioskLayoutType?.id;

    if (layoutTypeId) {
      httpParams = httpParams.append('layoutTypeId', layoutTypeId);
    }

    return this._apiService.get(
      `${this._basePath}/${this._terminalsStore.selectedTerminal().currentSession.kioskId}/products-and-package`,
      httpParams
    )
      .pipe(
        tap(res => {
          res.data.package.forEach(packageEl => {
            packageEl.packageContent = packageEl.packageContent.filter(pkgContent => {
              if (pkgContent.contentPackageId) {
                const nestedPackage = res.data.package.find(x => x.id === pkgContent.contentPackageId);
                pkgContent.contentPackage = nestedPackage;

                return !!nestedPackage;
              }

              const fProduct = res.data.products.find(x => x.id === pkgContent.productId);
              pkgContent.product = fProduct;

              return !!fProduct;
            });
          });

          this._kioskStore.kioskProductsAndPackages.set(res.data);
        })
      );
  }
}
